"use strict";

var _classCallCheck = require("/opt/build/repo/apps/multi-step-app/node_modules/.pnpm/@babel+runtime@7.16.5/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/opt/build/repo/apps/multi-step-app/node_modules/.pnpm/@babel+runtime@7.16.5/node_modules/@babel/runtime/helpers/createClass.js");

var _assertThisInitialized = require("/opt/build/repo/apps/multi-step-app/node_modules/.pnpm/@babel+runtime@7.16.5/node_modules/@babel/runtime/helpers/assertThisInitialized.js");

var _inherits = require("/opt/build/repo/apps/multi-step-app/node_modules/.pnpm/@babel+runtime@7.16.5/node_modules/@babel/runtime/helpers/inherits.js");

var _possibleConstructorReturn = require("/opt/build/repo/apps/multi-step-app/node_modules/.pnpm/@babel+runtime@7.16.5/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");

var _getPrototypeOf = require("/opt/build/repo/apps/multi-step-app/node_modules/.pnpm/@babel+runtime@7.16.5/node_modules/@babel/runtime/helpers/getPrototypeOf.js");

var _wrapNativeSuper = require("/opt/build/repo/apps/multi-step-app/node_modules/.pnpm/@babel+runtime@7.16.5/node_modules/@babel/runtime/helpers/wrapNativeSuper.js");

var _defineProperty = require("/opt/build/repo/apps/multi-step-app/node_modules/.pnpm/@babel+runtime@7.16.5/node_modules/@babel/runtime/helpers/defineProperty.js");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ResponseError = exports.RequestError = exports.CustomError = exports.isResponseErrorResult = exports.isRequestErrorResult = exports.isErrorResult = void 0;
var customErrors = ["request", "response"];

var objectifyError = function objectifyError(err) {
  return Object.getOwnPropertyNames(err).reduce(function (acc, key) {
    return Object.assign(acc, _defineProperty({}, key, err[key]));
  }, {});
};

var isErrorResult = function isErrorResult(result) {
  var _a, _b, _c;

  return ((_a = result) === null || _a === void 0 ? void 0 : _a.type) === "error" && !!((_b = result) === null || _b === void 0 ? void 0 : _b.data) && !!((_c = result) === null || _c === void 0 ? void 0 : _c.data.originalError);
};

exports.isErrorResult = isErrorResult;

var isCustomError = function isCustomError(result) {
  return result instanceof CustomError && customErrors.includes(result._type);
};

var isCustomErrorType = function isCustomErrorType(result, type) {
  return (0, exports.isErrorResult)(result) && isCustomError(result.data.originalError) && result.data.originalError._type === type || isCustomError(result) && result._type === type;
};

var isRequestErrorResult = function isRequestErrorResult(result) {
  return isCustomErrorType(result, "request");
};

exports.isRequestErrorResult = isRequestErrorResult;

var isResponseErrorResult = function isResponseErrorResult(result) {
  return isCustomErrorType(result, "response");
};

exports.isResponseErrorResult = isResponseErrorResult;

var CustomError = /*#__PURE__*/function (_Error) {
  _inherits(CustomError, _Error);

  var _super = _createSuper(CustomError);

  function CustomError(message, originalError, type) {
    var _this;

    _classCallCheck(this, CustomError);

    _this = _super.call(this, message);
    Object.assign(_assertThisInitialized(_this), objectifyError(originalError), {
      message: message,
      originalError: originalError
    });
    _this._type = type;
    return _this;
  }

  _createClass(CustomError, [{
    key: "toJSON",
    value: function toJSON() {
      return objectifyError(this);
    }
  }]);

  return CustomError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

exports.CustomError = CustomError;

var RequestError = /*#__PURE__*/function (_CustomError) {
  _inherits(RequestError, _CustomError);

  var _super2 = _createSuper(RequestError);

  function RequestError(message, originalError, body) {
    var _this2;

    _classCallCheck(this, RequestError);

    _this2 = _super2.call(this, message, originalError, "request");
    _this2.body = body;
    return _this2;
  }

  return _createClass(RequestError);
}(CustomError);

exports.RequestError = RequestError;

var ResponseError = /*#__PURE__*/function (_CustomError2) {
  _inherits(ResponseError, _CustomError2);

  var _super3 = _createSuper(ResponseError);

  function ResponseError(message, originalError, body) {
    var _this3;

    _classCallCheck(this, ResponseError);

    _this3 = _super3.call(this, message, originalError, "response");
    _this3.body = body;
    return _this3;
  }

  return _createClass(ResponseError);
}(CustomError);

exports.ResponseError = ResponseError;